var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ModuleWithProviders } from '@angular/core';
import * as Rx from 'rxjs';
import { REQUEST_DATA_CONFIG, REQUEST_DATA_INITIAL_CONFIG, } from './request-data.config';
var DEFAULT_DEDUPE_WINDOW = 10000;
var DEFAULT_BATCH_WINDOW = 250;
var ɵ0 = function (i, initialInterval) { return initialInterval * Math.pow(2, i); };
var DEFAULT_RETRY_CONFIG = {
    initialInterval: 200,
    maxRetries: 2,
    intervalFn: ɵ0,
};
export function createConfig(_options) {
    var DEFAULT_OPTIONS = {
        scheduler: Rx.asyncScheduler,
        dedupeWindowTime: DEFAULT_DEDUPE_WINDOW,
        batchWindowTime: DEFAULT_BATCH_WINDOW,
        retryConfig: DEFAULT_RETRY_CONFIG,
    };
    var options = typeof _options === 'function' ? _options() : _options;
    var config = __assign({}, DEFAULT_OPTIONS, options);
    if (config.dedupeWindowTime < 0) {
        throw new Error("RequestData dedupe window must be non-negative, got " + config.dedupeWindowTime);
    }
    if (config.batchWindowTime < 0) {
        throw new Error("RequestData batch window must be non-negative, got " + config.batchWindowTime);
    }
    return config;
}
var RequestDataModule = /** @class */ (function () {
    function RequestDataModule() {
    }
    RequestDataModule.initialize = function () {
        return {
            ngModule: RequestDataModule,
            providers: [
                {
                    provide: REQUEST_DATA_CONFIG,
                    deps: [REQUEST_DATA_INITIAL_CONFIG],
                    useFactory: createConfig,
                },
            ],
        };
    };
    return RequestDataModule;
}());
export { RequestDataModule };
export { ɵ0 };
